module.exports = __webpack_public_path__ + "img/filter.66268e6d.svg";